if (!customElements.get('shipping-countdown')) {
  class ShippingCountdown extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      this.textBefore = this.dataset.textBefore;
      this.textAfter = this.dataset.textAfter;
      this.textTomorrow = this.dataset.textTomorrow;
      this.textWeekend = this.dataset.textWeekend;
      this.messageEl = this.querySelector('.product--shipping-countdown-message');

      this.update();
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    update() {
      clearInterval(this._interval);

      const now = new Date();
      const day = now.getDay(); // 0=Sun,1=Mon,...,5=Fri,6=Sat
      const hour = now.getHours();

      // Friday after cutoff OR Saturday → weekend text
      if (day === 6 || (day === 5 && hour >= this.cutoffHour)) {
        this._show(this.textWeekend);
        return;
      }

      // Sunday OR Mon-Thu after cutoff → "vi sender i morgen"
      if (day === 0 || (day >= 1 && day <= 4 && hour >= this.cutoffHour)) {
        this._show(this.textTomorrow);
        return;
      }

      // Mon-Fri before cutoff → live countdown
      if (day >= 1 && day <= 5 && hour < this.cutoffHour) {
        this._tick();
        this._interval = setInterval(() => this._tick(), 1000);
      }
    }

    _tick() {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setHours(this.cutoffHour, 0, 0, 0);
      const diff = cutoff - now;

      if (diff <= 0) {
        clearInterval(this._interval);
        this.update();
        return;
      }

      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      let timeStr = '';
      if (h > 0) timeStr += `${h}t `;
      timeStr += `${String(m).padStart(h > 0 ? 2 : 1, '0')}m `;
      timeStr += `${String(s).padStart(2, '0')}s`;

      const parts = [];
      if (this.textBefore) parts.push(this.textBefore);
      parts.push(`<strong>${timeStr.trim()}</strong>`);
      if (this.textAfter) parts.push(this.textAfter);

      this.messageEl.innerHTML = parts.join(' ');
      this.removeAttribute('hidden');
    }

    _show(text) {
      if (!text) return;
      this.messageEl.textContent = text;
      this.removeAttribute('hidden');
    }
  }

  customElements.define('shipping-countdown', ShippingCountdown);
}
